<template>
  <div class="contentHome">
    <template>
      <el-backtop target="#app" :visibility-height="10" class="backTop" :right="50" :bottom="100">
        <img src="../../assets/img/backTop.png" alt="" width="32">
      </el-backtop>
    </template>
    <div class="centerPage">
      <el-tabs value="all" class="tabs" @tab-click="handleClick">
        <el-tab-pane :name="obj.name" :label="obj.label" v-for="(obj,ind) in consultJson" :key="ind">
          <div class="typeHead">

            <div class="medicineType flex city-box">
              <span class="typeTit">所在城市：</span>
              <div class="medicineTypeL city" id="city-list" :isOpen="cityMore.open">
								<span>
									<label :class="cityActive==0?'activeClass':''" @click="changeCity(0)">不限</label>
								</span>
                <!--循环内容-->
                <span v-for="(item,index) in cityList" :key="index">
									<label :class="cityActive==index+1?'activeClass':''"
                         @click="changeCity(index+1,item)">{{ item.cnName }}</label>
								</span>
              </div>
              <span class="city-more" v-if="cityMore.show"
                    @click="toggleCityBox">{{ cityMore.open ? '收起' : '更多' }}</span>
            </div>

            <div class="medicineType flex city-box">
              <span class="typeTit">科室：</span>
              <div class="medicineTypeL city" id="tags-list" :isOpen="tagMore.open">
								<span>
									<label :class="tagMore.active==0?'activeClass':''" @click="changeTag(0)">不限</label>
								</span>
                <!--循环内容-->
                <span v-for="(item,index) in tagMore.list" :key="index">
									<label :class="tagMore.active==index+1?'activeClass':''"
                         @click="changeTag(index+1,item)">{{ item }}</label>
								</span>
              </div>
              <span class="city-more" v-if="tagMore.show"
                    @click="tagMore.open = !tagMore.open">{{ tagMore.open ? '收起' : '更多' }}</span>
            </div>

            <div class="medicineType flex city-box">
              <span class="typeTit">服务类型：</span>
              <div class="medicineTypeL city" id="type-list" :isOpen="typeMore.open">
								<span>
									<label :class="typeMore.active==0?'activeClass':''" @click="changeIndication(0)">不限</label>
								</span>
                <!--循环内容-->
                <span v-for="(item,index) in indicationList" :key="index">
									<label :class="typeMore.active==index+1?'activeClass':''"
                         @click="changeIndication(index+1,item.id)">{{ item.cnName }}</label>
								</span>
              </div>
              <span class="city-more" v-if="typeMore.show"
                    @click="typeMore.open = !typeMore.open">{{ typeMore.open ? '收起' : '更多' }}</span>
            </div>

            <div class="medicineType flex">
              <span class="typeTit">可约时间：</span>
              <div class="medicineTypeL">
                                <span><label :class="appTimeActive==0?'activeClass':''"
                                             @click="changeAppTime(0)">不限</label></span>
                <!--循环内容-->
                <span v-for="(item,index) in appTimeList" :key="index">
                                        <label :class="appTimeActive==index+1?'activeClass':''"
                                               @click="changeAppTime(index+1,item.id)">{{ item.itemName }}</label>
                                    </span>
              </div>
            </div>
            <div class="medicineType flex">
              <span class="typeTit">咨询方式：</span>
              <div class="medicineTypeL">
                <span>
									<label :class="modeActive==0?'activeClass':''" @click="changeMode(0)">不限</label>
								</span>
                <span>
									<label :class="modeActive==1?'activeClass':''" @click="changeMode(1)">语音咨询</label>
								</span>
                <span>
									<label :class="modeActive==2?'activeClass':''" @click="changeMode(2)">视频咨询</label>
								</span>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="leftCon ">
              <div v-if="famousDoctorList.length==0" style="text-align: center;color: #DFE0E7;width: 100%">
                <img src="../../assets/img/empty_tips.png" alt="" style="width: 320px;">
                <div>暂无数据</div>
              </div>
              <div class="userList flex" v-for="(obj,index) in famousDoctorList" :key="index">
                <div v-if="obj.headImgPath" class="objImg img" :style="'backgroundImage: url('+obj.headImgPath+')'"
                     @click="toDetail(obj.account)">
                  <div class="tags" :type="obj.medicineType"></div>
                </div>
                <div v-else @click="toDetail(obj.account)" class="objImg img default-headImg" :gender="obj.gender">
                  <div class="tags img" :type="obj.medicineType"></div>
                </div>
                <div class="right">
                  <div @click="toDetail(obj.account)" style=" cursor: pointer;">
                    <div class="flex">
                      <h2>{{ obj.fullName }} {{ obj.enName }}</h2>
                      <span class="serviceLength"
                            v-html="obj.age===0?'今年从业':('从业<strong>'+obj.age+'</strong></span>年')"></span>
                    </div>
                    <span class="count">已咨询<strong>{{ obj.supplement.consultationCount }}</strong>人</span>
                    <div style="clear:both;"></div>
                    <p class="post overFlow">{{ obj.company }} {{ obj.technicalTitle }}</p>
                    <p class="motto">{{ obj.signature }}</p>
                    <span class="language-tag ">{{ obj.languages.join('/') }}</span>
                  </div>
                  <div class="flex" style="justify-content: space-between;width: 100%;">
                    <p class="pay">
                      {{ obj.initialCharge }}元/{{obj.initialMinute }}分钟
                      <template v-if="obj.supplement.specialNote">（{{ obj.supplement.specialNote }}）</template>
                    </p>
                    <!--<span class="pay" v-else>{{obj.initialCharge}}元/分钟</span>-->
                    <div>
                      <el-button v-if="userType<2" @click="toDetail(obj.account)">咨询</el-button>
                      <shortChat :user-id="obj.id" style="margin-right: 12px"
                                 v-if="getUserId && getUserId != obj.id"></shortChat>
                    </div>

                  </div>
                </div>
              </div>
              <!--分页-->
              <el-pagination
                  :hide-on-single-page="true"
                  class="pagination"
                  background
                  prev-text="Prev"
                  next-text="Next"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="prev, pager, next"
                  :total="total">
              </el-pagination>
            </div>
            <div class="rightCon">
              <p class="title">咨询指南</p>
              <el-popover
                  popper-class="popGu"
                  class="popGuide"
                  v-for="item in guide"
                  :key="item.id"
                  placement="left-start"
                  :title="item.title"
                  width="556"
                  trigger="hover">
                <el-button slot="reference">{{ item.title }}</el-button>
                <div class="popContent">{{ item.content }}</div>
              </el-popover>
              <div class="doubt">
                <span><img src="../../assets/img/consult_a.png" alt="" width="23"></span>
                对心理咨询还有疑问？<br> 客服为您竭诚服务
                <span><img src="../../assets/img/consult_b.png" alt="" width="23"></span>
              </div>
              <!--              <el-button class="customer" @click="contactServer">联系客服</el-button>-->
              <el-button class="customer"><a
                  :href="userType===2?'/doctor/doctorHelp':'/helpCenter?smallTit=咨询'">帮助中心</a>
              </el-button>
            </div>
            <div style="clear: both"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-input class="addART"
                placeholder="搜索医生名字"
                v-model="search" suffix-icon="el-icon-search" @change="changeName()">
      </el-input>
    </div>
    <!--    悬浮框-->
    <suspensionDrawer></suspensionDrawer>

    <!-- 登录弹窗 -->
    <loginDialog ref="loginDialog"></loginDialog>


  </div>
</template>

<script>
import commonjs from "@/api/common";
import loginDialog from "../loginDialog";
import shortChat from "../common/shortChat";
import suspensionDrawer from "../suspensionDrawer";

export default {
  name: "consult",
  components: {loginDialog, shortChat, suspensionDrawer},
  data() {
    return {
      condition: [],
      active: 0,
      userList: [],
      guide: [],

      search: '',//搜索
      consultJson: [{
        name: 'all',
        label: '全部'
      }],
      lastTabName: 'all', //避免不必要的点击
      activeName: '0',//全部我的
      getUserId: '',//当前用户id
      userType: 0,

      famousDoctorList: [],//著名专家
      age: '',//从业时间

      cityList: [],//所有所在在城市
      cityActive: 0,

      appTimeList: {},//所有可预约时间
      appTimeActive: 0,

      indicationList: {},//所有服务类型
      indicationActive: 0,

      modeList: ['不限', '语音咨询', '视频咨询'],//所有咨询方式
      modeActive: 0,

      getCondition: {
        abodeCity: '',//所在城市
        appointTimeSlot: '',//可约时间
        consultMode: '',//咨询方式
        indicationId: '',//服务类型
        fullName: '',//医生名字
        userId: '',//当前用户id
        // isDone: 0,
        tagName: '',// 标签
        tagType: 1,// 科室标签
        isConcern: false,
        excludeCloseAppoint: 1,
      },//查询条件
      currentPage: 1,// 当前页
      pageSize: 5,// 每页多少条
      total: 0,//该标签文章总数

      cityMore: {
        show: false,
        open: false
      },
      typeMore: {
        active: 0,
        show: false,
        open: false
      },
      tagMore: {
        active: 0,
        list: [],
        show: false,
        open: false
      },

    }
  },
  async mounted() {

    let currentUser = await commonjs.utils.getCurrent();//获取当前登录的用户id
    if (currentUser != null) {
      this.getUserId = currentUser.id;
      this.userType = currentUser.type;
      this.getCondition.userId = this.getUserId;
      // this.getCondition.isDone = 1;
      this.getFamousDoctors();//著名专家
    } else {
      this.getFamousDoctors();//著名专家

    }
    this.getUser();//当前用户
    this.getCity();//所在城市
    this.getAppTime();//可约时间
    this.getIndication();//服务类型

    // 科室信息
    let that = this;
    that.$ajax.get(commonjs.api.famousDoctor.department_tags).then(res => {
      if (res.data.status === 'success') {
        that.tagMore.list = res.data.list;
        that.$nextTick(() => {
          let tag_show_height = $('#tags-list').height();
          let tag_real_height = document.getElementById('tags-list').scrollHeight;
          if (tag_show_height < tag_real_height) { //存在隐藏内容
            that.tagMore.show = true;
          }
        });
      }
    });

  },
  methods: {
    toggleCityBox() {
      this.cityMore.open = !this.cityMore.open;
    },
    change(index, id, type) {
      this.active = index
    },
    async toDetail(account) {

      let vm = this;
      let user = await commonjs.utils.getCurrent();
      if (user == null) {
        vm.$refs.loginDialog.dialogVisible = true;
        vm.$refs.loginDialog.reloadCode('vcode-user');
        vm.$refs.loginDialog.successUrl = '/order/' + account;
      } else {
        if (user.type === 2) {
          this.$message.error("医生不允许预约");
        } else {
          // sessionStorage.removeItem('choosed');
          this.$router.push({path: '/order/' + account});
        }
      }

      // this.$router.push({path: 'doctorDetail/' + account})
    },

    //获取著名专家
    getFamousDoctors() {
      let vm = this, url;
      if (!vm.getCondition.isConcern) { // 全部
        url = commonjs.api.famousDoctor.conditionPage;
      } else { // 我的
        url = commonjs.api.famousDoctor.concernPage;
      }

      let data = {
        isOpenAppoint: 1,
        abodeCity: vm.getCondition.abodeCity,
        timeSlot: vm.getCondition.appointTimeSlot,
        indicationId: vm.getCondition.indicationId,
        consultMode: vm.getCondition.consultMode,
        current: vm.currentPage,
        size: vm.pageSize,
        tagName: vm.getCondition.tagName,
        tagType: vm.getCondition.tagType
      };

      this.$ajax.post(url, data).then(function (res) {
        if (res.data.status === 'success') {
          $(res.data.rows).each((i, item) => {
            // 时间处理
            item.age = new Date().getFullYear() - new Date(item.startWorkDate).getFullYear();
            // supplement处理
            if (item.supplement) {
              item.chargeType = item.supplement.chargeType;
              item.initialCharge = item.supplement.initialCharge;
              item.initialMinute = item.supplement.initialMinute;
              item.furtherCharge = item.supplement.furtherCharge;
              item.furtherMinute = item.supplement.furtherMinute;
              item.signature = item.supplement.signature;
            }
          });
          vm.famousDoctorList = res.data.rows;
          vm.total = res.data.total;
        }
      })
    },
    //获得专家所在城市
    getCity() {
      let vm = this;
      this.$ajax.get(commonjs.api.famousDoctor.city_group).then(res => {
        if (res.data.status === 'success') {
          $(res.data.list).each((i, o) => {
            vm.cityList.push({cnName: o, enName: ''});
          });
          vm.$nextTick(() => {
            let show_height = $('#city-list').height();
            let real_height = document.getElementById('city-list').scrollHeight;
            if (show_height < real_height) { //存在隐藏内容
              vm.cityMore.show = true;
            }
          });
        }
      });
    },
    //改变所在城市
    changeCity(index, item) {
      this.cityActive = index;
      this.getCondition.abodeCity = '';
      this.getCondition.abodeCityEn = '';
      if (item) {
        this.getCondition.abodeCity = item.cnName;
        if (item.enName) {
          this.getCondition.abodeCityEn = item.enName;
        }
      }
      this.getFamousDoctors();
    },
    //获取可约时间
    getAppTime() {
      let vm = this;
      this.$ajax
          .get(commonjs.api.famousDoctor.appTime)
          .then(function (res) {
            if (res.data.status === 'success') {
              vm.appTimeList = res.data.list;
            }
          })
    },
    //改变可预约时间
    changeAppTime(index, id) {
      this.appTimeActive = index;
      this.getCondition.appointTimeSlot = id;
      this.getFamousDoctors();
    },
    //获取服务类型
    getIndication() {
      let vm = this;
      this.$ajax.get(commonjs.api.famousDoctor.indication).then(function (res) {
        if (res.data.status === 'success') {
          vm.indicationList = res.data.list;
          vm.$nextTick(() => {
            let type_show_height = $('#type-list').height();
            let type_real_height = document.getElementById('type-list').scrollHeight;
            if (type_show_height < type_real_height) { //存在隐藏内容
              vm.typeMore.show = true;
            }
          });
        }
      })
    },
    //改变服务类型
    changeIndication(index, id) {
      this.currentPage = 1;
      this.typeMore.active = index;
      this.getCondition.indicationId = id;
      this.getFamousDoctors();
    },
    //改变咨询方式
    changeMode(index) {
      this.currentPage = 1;
      this.modeActive = index;
      this.getCondition.consultMode = index;
      this.getFamousDoctors();
    },
    //搜索名字
    changeName() {
      this.currentPage = 1;
      this.getCondition.fullName = this.search;
      this.getFamousDoctors();
    },
    // 每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 当前页  根据标签页分别执行传输
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getFamousDoctors();
      this.$nextTick(() => {
        $(".contentIndex").animate({scrollTop: '0px'}, 800);
      });
    },
    //全部/我的 点击事件
    handleClick(tab) {
      if (tab.name === this.lastTabName) {
        return;
      }
      this.getCondition.isConcern = false;
      this.getCondition.userId = null;
      if (tab.name === "concern") {
        this.getCondition.userId = this.getUserId;
        this.getCondition.isConcern = true;
      }
      this.getFamousDoctors();
      this.lastTabName = tab.name;
    },
    //获得当前用户id
    getUser() {
      if (this.getUserId && this.userType == 1) {
        this.consultJson.push({
          name: 'concern',
          label: '我的关注'
        })
      }
    },
    contactServer() {
      let iTop = (window.screen.height - 30 - 640) / 2;       //获得窗口的垂直位置;
      let iLeft = (window.screen.width - 10 - 530) / 2;        //获得窗口的水平位置;
      window.open("/chatClient", "chat", "width=530,height=640,location=false,top=" + iTop + ",left=" + iLeft);
    },
    changeTag(index, item) {
      this.currentPage = 1;
      this.tagMore.active = index;
      this.getCondition.tagName = item;
      this.getFamousDoctors();
    },

  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/consult_a.scss';
</style>
